meedy.factory('meedy.newUserRegistrationService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, baseService, objectHelper, config) {

        function NewUserRegistrationService() {

            this.register = function (newUserWrapper) {
                var d = $q.defer();

                baseService.post(config.API_URL + '/doctors/register', newUserWrapper).then(
                    function (successResponse) {

                        d.resolve(successResponse);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };
        }

        return new NewUserRegistrationService();
    }
]);
